import { create } from 'zustand';

type Fuctionarys = {
  data: any[];
  setFunctionarysData: (data: any[]) => void;
};

export const useFunctionarysDataStore = create<Fuctionarys>((set, get) => ({
  data: [],
  setFunctionarysData: data => set(() => ({ data: data })),
  action: () => {
    const data = get().data;
    // ...
  },
}));
